import { render } from "./Telefono.vue?vue&type=template&id=470cfaf0&scoped=true"
import script from "./Telefono.vue?vue&type=script&lang=js"
export * from "./Telefono.vue?vue&type=script&lang=js"

import "./Telefono.vue?vue&type=style&index=0&id=470cfaf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470cfaf0"]])

export default __exports__